import { render, staticRenderFns } from "./AuctionOtherFeeForm.vue?vue&type=template&id=58e74cb8&"
import script from "./AuctionOtherFeeForm.vue?vue&type=script&lang=js&"
export * from "./AuctionOtherFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports